import ZakazkaPage from "../pages/customer/order/ZakazkaPage";
import ZakaznikPage from "../pages/customer/order/ZakaznikPage";
import DopravaPage from "../pages/customer/order/DopravaPage";
import PlatbaPage from "../pages/customer/order/PlatbaPage";
import PotvrzeniPage from "../pages/customer/order/PotvrzeniPage";

export const ADMIN_BASE_PATH = "administrace";
export const SPOLECNOSTI_PATH = "spolecnosti";
export const UZIVATELE_PATH = "uzivatele";
export const DOPRAVA_PATH = "doprava";
export const ORDER_BASE_PATH = "objednavka";
export const ORDERS_BASE_PATH = "objednavky";

// Konstanty používané komponentami jako ID pro přesměrování
export const ZAKAZKA = 'zakazka';
export const ZAKAZNIK = 'zakaznik';
export const DOPRAVA = 'doprava';
export const PLATBA = 'platba';
export const POTVRZENI = 'potvrzeni';

/**
 * Definice jednotlivých kroků objednávky, včetně routes a komponent.
 * Pozor, záleží na pořadí - jednotlivé stránky a komponenty používají toto pole pro určení pořadí kroků objednávky.
 */
export const ORDER_ROUTES = [
    // key je klíč pro i18n
    {id: ZAKAZKA, key: 'order.step.order', path: `/${ORDER_BASE_PATH}/zakazka`, component: ZakazkaPage},
    {id: ZAKAZNIK, key: 'order.step.customer', path: `/${ORDER_BASE_PATH}/zakaznik`, component: ZakaznikPage},
    {id: DOPRAVA, key: 'order.step.delivery', path: `/${ORDER_BASE_PATH}/doprava`, component: DopravaPage},
    {id: PLATBA, key: 'order.step.payment', path: `/${ORDER_BASE_PATH}/platba`, component: PlatbaPage},
    {id: POTVRZENI, key: 'order.step.order_confirmation', path: `/${ORDER_BASE_PATH}/potvrzeni`, component: PotvrzeniPage, final: true},
];
